import { createSelector } from "@reduxjs/toolkit";

export const selectMenu = (state) => state.menu;

export const selectShowMenu = createSelector(
    selectMenu,
    (menu) => menu.isShown
);

export const selectIsOpenedMenu = createSelector(
    selectMenu,
    (menu) => menu.isOpen
);
